<template>
  <app-page class="shop pt-0">
    <shop-eyecatch :profile="profile" />
    <shop-do class="my-12" :profile="profile" />
    <section class="my-12">
      <h1><span>店舗情報</span></h1>
      <shop-profile :profile="profile" />
    </section>
    <section class="my-12"
      v-for="(item, index) in announces"
      :key="index"
    >
      <h1><span>{{item.subject}}</span></h1>
      <shop-announce :html="item.html" />
    </section>
    <shop-do class="my-12" :profile="profile" />
  </app-page>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.shop {
  section > h1 {
    @extend %typo-subtitle-1;
    margin-bottom: 2rem;
    text-align: center;

    > span {
      display: inline-block;
      padding: 0 1rem 3px 1rem;
      color: $key-color;
      border-bottom: dashed 1px $key-color;
      letter-spacing: 0.25em;
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import ShopBase from '@/app/special/mixins/ShopBase'
import ShopEyecatch from './ShopEyecatch'
import ShopDo from './ShopDo'
import ShopProfile from './ShopProfile'
import ShopAnnounce from './ShopAnnounce'

export default {
  name: 'Shop',
  components: {
    ShopEyecatch,
    ShopDo,
    ShopProfile,
    ShopAnnounce
  },
  mixins: [
    ShopBase('店舗紹介')
  ],
  computed: {
    ...mapGetters('shop', [
      'profile'
    ]),

    announces () {
      if (!this.profile.extra || !this.profile.extra.announces) {
        return []
      }
      return this.profile.extra.announces
    }
  },
  watch: {
    profile (profile) {
      this.pageTitle = profile.name
    }
  }
}
</script>
